import styled from 'styled-components';

import { Checkbox, RadioButton } from '@notino/react-styleguide-v20';

export const StyledCheckbox = styled(Checkbox)`
  font-weight: 400;
`;

export const StyledRadioButton = styled(RadioButton)`
  font-weight: 400;
`;
